/**
 * 分享 (小程序,app的分享)
 * h5的分享在wechatJsSdk
 */
import { isWeChat } from '@/utils/util.js'

var jweixin = require('jweixin-module');
import wx from "weixin-js-sdk"
import wechatJsSdk from '@/utils/wechatJsSdk.js'
import store from '@/store/index.js'; // VUEX

// 获取链接
export function getHref(url){
	let href = url || window.location.href;
	let hrefIndex = href.indexOf("#");
	let hrefTwoIndex = href.indexOf("?")
	if((hrefIndex == -1 && hrefTwoIndex != -1) || (hrefTwoIndex != -1 && hrefIndex > hrefTwoIndex)){
	  href = href.split("?")[0];
	} else {
		href = href.split("#")[0];
	}
	return href;
}

// 获取链接参数并追加传递进来的参数(去重)
function getUrlValue(url,data = {}){
	let index = url.indexOf("?");
	url = url.substr(index + 1);
	if(index == -1 || url == '') return data;
	let arr = url.split("&");
	let obj = {};
	arr.forEach((v) => {
		let val = v.split("=");
		obj[val[0]] = val[1] || ""
	})
	Object.assign(obj,data);
	return obj;
}

// 拆分数据
function splitData(data = {}) {
    let url = '';
    for (let k in data) {
        if (data.hasOwnProperty(k)) {
            let value = data[k] || ''
			if(typeof data[k] == 'number' && data[k] == 0) value = 0;
            url = url + '&' + k + '=' + encodeURIComponent(value)
        }
    }
    return url ? url.substring(1) : ''
}

/**
 * @description 拼接参数
 * @property {String} url 链接
 * @property {String} data 额外追加的参数
 */
function contractUrl(url, data = {}) {
	let resultObj = getUrlValue(url,data); // 过滤出能拼接得对象 -- 去重
	const queryUrl = splitData(resultObj); //链接参数转字符串
	let index = url.indexOf("?"); 
	index = index != -1 && queryUrl.length > 0?index + 1:index;
	url = index == -1?queryUrl.length > 0?url + "?":url:url.substr(0,index);
    return url + queryUrl;
}

// 处理分享的data (缺默认值)
function initShareData(data = {},url){
	let logo = uni.getStorageSync('logo') || ''
	let newData = {
		title: '',
		desc: '',
		link: url,
		imgUrl: logo || '',
	}
	for (let key in data) {
		newData[key] = data[key]
	}
	return newData;
}
export default {
	getUrl(n = 1) {
		let pages = getCurrentPages();
		let curPage = pages[pages.length - 1];
		let url = ''

		url = curPage.$route.fullPath;

		



		return url.substring(n, url.length);
	},
	/**
	 * 拼接url
	 * @param {String} path 页面路径 可携带参数 默认会携带sign和pid
	 */
	splicUrl(path = '/pages/index/index') {
		let sign = uni.getStorageSync("sign");
		let user = uni.getStorageSync("userInfo") ? uni.getStorageSync("userInfo") : {};
		let _url = path;
		const queryObj = { // 拼接得参数
			sign,
			pid: user.user_id || -1,
			mtaShareFlag: 1
		}
		_url = contractUrl(_url,queryObj);
		return _url
	},
	// title: '', // 分享标题
	// desc: '', // 分享描述
	// link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
	// imgUrl: '', // 分享图标
	
	// data.title 分享标题
	// data.desc 分享描述
	// data.path 分享路径
	// data.imageUrl 分享图片
	
	
	/**
	 * 公众号分享
	 * @description 此方法仅供公众号使用
	 * @param { object } data 分享数据 
	 * @param { string } data.title 分享标题
	 * @param { string } data.desc 分享描述 
	 * @param { string } data.app_share_pic 分享图片地址
	 * @param { string } data.link 分享链接
	 * @param { string } url 自定义页面URL
	 * 例 { app_share_title: '', app_share_desc: '', link: url, app_share_pic: logo || '',}
	 */
	initShareUrl(data, url) {
		let sign = uni.getStorageSync("sign");
		let user = uni.getStorageSync("userInfo") ? uni.getStorageSync("userInfo") : {};
		const queryObj = { // 拼接得参数
			sign,
			pid: user.user_id || -1,
			share_type: 1,
			mtaShareFlag: 1
		}
		let href = getHref(); //获取当前链接
		let page = this.getUrl(); //获取当前页面路径并带参数
		if(url) page = url;
		let _url = `${href}#/${page}`;
		_url = contractUrl(_url, queryObj);
		
		console.log("_url:",_url)
		this.shareUrl(data, _url);
	},
	
	//在需要自定义分享的页面中调用
	shareUrl: function(data = {}, url) {
		if(!isWeChat()){
			console.log('不是微信客户端')
			return false
		}
		/*判断是微信浏览器还是公众号h5*/
		if(window.__wxjs_environment === 'miniprogram'){
			//微信浏览器环境
			wechatJsSdk.initWeixinsdk(function(signData) {
				wx.ready(function() {
					let data1 = {title:data.share_title,desc:data.share_desc,link:data.share_link,imgUrl:data.share_pic}
					let shareData = initShareData(data1,url);
					console.log(shareData, '------shareData------')
					wx.onMenuShareAppMessage({
						title:data.share_title,
						desc:data.share_desc,
						link:data.share_link,
						type:"link",
						imgUrl:data.share_pic
					})
					//分享给朋友接口  
					wx.updateAppMessageShareData(shareData);
					//分享到朋友圈接口  
					wx.updateTimelineShareData(shareData);
					// title问题 - 去除会不显示
					wx.onMenuShareTimeline(shareData); // 即将废弃
				});
			}, url);
		}else{
			//公众号环境
			//每次都需要重新初始化配置，才可以进行分享
			wechatJsSdk.initJssdk(function(signData) {
				jweixin.ready(function() {
					let shareData = initShareData(data,url);
					console.log(shareData, '------shareData------')
					//分享给朋友接口  
					jweixin.updateAppMessageShareData(shareData);
					//分享到朋友圈接口  
					jweixin.updateTimelineShareData(shareData);
					// title问题 - 去除会不显示
					jweixin.onMenuShareTimeline(shareData); // 即将废弃
				});
			}, url);
		}
	},
	/**
	 * 小程序分享
	 * @param {Object} data 
	 * @param {string} data.title 分享标题
	 * @param {string} data.path 分享路径
	 * @param {string} data.imageUrl 分享图片
	 * @param {string} data.desc 分享描述
	 */
	wxShare(data) {
		let shareInfo = {
			title: data.title,
			imageUrl: data.imgUrl
		};
		shareInfo.path = this.splicUrl(this.getUrl(0))
		if (data.desc) shareInfo.desc = data.desc;
		return shareInfo;
	},
	/**
	 * APP分享
	 * @param {object} data 分享参数
	 * @param {Number} data.type 分享形式，如0:图文、1:纯文字、2:纯图片、3:音乐、4:视频、5:小程序等。默认图文 0
	 * @param {String} data.title 分享内容的标题
	 * @param {String} data.scene 场景 provider 为 weixin 时必选 默认分享到聊天界面
	 * @param {String} data.summary 分享内容的摘要 type 为 1 时必选 
	 * @param {String} data.path 页面路径 type 为 0 和 5 时必选
	 * @param {String} data.imageUrl 图片地址。type为0时，推荐使用小于20Kb的图片
	 * @param {String} data.mediaUrl 音视频地址
	 * @param {string} channel 分享渠道 默认weixin
	 */
	appShare(data, channel) {
		let shareData = {
			provider: channel || 'weixin',
			type: data.type || 0,
			title: data.title,
			success: (res) => {
				console.log("success:" + JSON.stringify(res));
			},
			fail: (res) => {
				console.log("fail:" + JSON.stringify(err));
			}
		}
		if (shareData.provider == 'weixin') shareData.scene = data.scene || 'WXSceneSession'
		if (shareData.type == 1) shareData.summary = data.summary
		if (shareData.type == 0) shareData.href = this.splicUrl(data.path)
		if (shareData.type == 0 || shareData.type == 2 || shareData.type == 5) shareData.imageUrl = data.imageUrl
		if (shareData.type == 3 || shareData.type == 4) shareData.mediaUrl = data.mediaUrl
		if (shareData.type == 5) {
			shareData.miniProgram = {
				id: api.weixinOriginalId,
				path: this.splicUrl(data.path),
				type: 0, // 0-正式版； 1-测试版； 2-体验版。 默认值为0。
				webUrl: 'http://uniapp.dcloud.io'
			}
		}
		uni.share(shareData)
	}
}